/**
 * SeletorDeTema — Claro / Escuro / Sistema, sem regra de horário (padrão A, item 6).
 *
 * Grupo de três opções (`role="radiogroup"`): o estado é lido sem depender de cor (a opção escolhida tem
 * contorno e ícone mais cheio) e o teclado é o de rádio — Tab entra no grupo UMA vez, setas trocam.
 * `variante="cheia"` mostra o nome ao lado do ícone (bloco "Conta" da gaveta); a compacta só o ícone com
 * nome acessível (barra superior).
 */
import { Monitor, Moon, Sun } from "lucide-react";
import { useRef } from "react";
import type { PreferenciaTema } from "./tipos.js";
import { junta } from "./util.js";

const OPCOES: { v: PreferenciaTema; rotulo: string; Icone: typeof Sun }[] = [
  { v: "claro", rotulo: "Claro", Icone: Sun },
  { v: "escuro", rotulo: "Escuro", Icone: Moon },
  { v: "sistema", rotulo: "Sistema", Icone: Monitor },
];

export function SeletorDeTema({
  preferencia,
  aoMudar,
  variante = "compacta",
  className,
}: {
  preferencia: PreferenciaTema;
  aoMudar: (p: PreferenciaTema) => void;
  variante?: "compacta" | "cheia";
  className?: string;
}) {
  const refs = useRef<Array<HTMLButtonElement | null>>([]);
  const mover = (de: number, passo: number) => {
    const para = (de + passo + OPCOES.length) % OPCOES.length;
    aoMudar(OPCOES[para]!.v);
    refs.current[para]?.focus();
  };
  return (
    <div role="radiogroup" aria-label="Tema da tela" className={junta("casca-tema", variante === "cheia" && "casca-tema-cheia", className)}>
      {OPCOES.map(({ v, rotulo, Icone }, i) => {
        const marcado = preferencia === v;
        return (
          <button
            key={v}
            ref={(el) => { refs.current[i] = el; }}
            type="button"
            role="radio"
            aria-checked={marcado}
            aria-label={variante === "compacta" ? `Tema ${rotulo.toLowerCase()}` : undefined}
            title={`Tema ${rotulo.toLowerCase()}`}
            tabIndex={marcado ? 0 : -1}
            className="casca-tema-op"
            onClick={() => aoMudar(v)}
            onKeyDown={(e) => {
              if (e.key === "ArrowRight" || e.key === "ArrowDown") { e.preventDefault(); mover(i, 1); }
              else if (e.key === "ArrowLeft" || e.key === "ArrowUp") { e.preventDefault(); mover(i, -1); }
            }}
          >
            <Icone size={18} strokeWidth={marcado ? 2.25 : 1.75} aria-hidden="true" />
            {variante === "cheia" && <span>{rotulo}</span>}
          </button>
        );
      })}
    </div>
  );
}
